import * as React from "react"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

const Hero = () => (
    <div className="hero-wrapper" style={{ display: "grid" }}>
      <StaticImage
        style={{
          gridArea: "1/1",          
        }}
        layout="fullWidth" 
        loading="eager" 
        aspectRatio={3 / 1}
        alt="97 Automotive Shop in Millersville MD"
        src="../images/shop_splash.jpg"
        formats={["auto", "jpg", "avif"]}
      />
      <div
        style={{
          gridArea: "1/1",
          position: "relative",
          placeItems: "center",
          display: "grid",          
        }}
      >
        <h1 className="hero-h1">
            Automotive Enhancements and Repairs
        </h1>
      </div>
      <div
        style={{
          gridArea: "1/1",
          position: "relative",
          placeItems: "center",
          display: "grid",
          marginTop: "120px"          
        }}
      >
        
        <Link to="/contact">CONTACT US TODAY!</Link>
      </div>
    </div>
  )
  
  export default Hero